import React, { useState,useEffect } from "react";
import "./internshipcontrols.css";

const CertificateTemplateManager = () => {
  const [mode, setMode] = useState(""); 
  const [certificateType, setCertificateType] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const[config,setConfig]=useState(null);


   useEffect(() => {
      const loadConfig = async () => {
        try {
          const res = await fetch("/config.json");
          const data = await res.json();
          setConfig(data);
        } catch (err) {
          console.error("Error loading config.json", err);
        }
      };
      loadConfig();
    }, []);

  const handleFileChange = (e) => {
    setPdfFile(e.target.files[0]);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!certificateType || !pdfFile) {
    alert("Please select a certificate type and upload a PDF.");
    return;
  }

  const formData = new FormData();
  formData.append("certificate_type", certificateType);
  formData.append("pdf", pdfFile);

  // Backend URLs using config
  const addUrl = `${config.BASE_URL}${config.ADD_TEMPLATE}`;
  const updateUrl = `${config.BASE_URL}${config.UPDATE_TEMPLATE}`;

  const url = mode === "add" ? addUrl : updateUrl;

  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();
    alert(result.message);
  } catch (error) {
    console.error("Error:", error);
    alert("Something went wrong. Try again.");
  }
};


  return (
    <div className="ctm-wrapper">
      <div className="ctm-container">
        <h2 className="ctm-title">Certificate Templates</h2>

        <div className="ctm-btn-group">
          <button
            className={`ctm-btn ${mode === "add" ? "ctm-active" : ""}`}
            onClick={() => setMode("add")}
          >
            Add Template
          </button>
          <button
            className={`ctm-btn ${mode === "update" ? "ctm-active" : ""}`}
            onClick={() => setMode("update")}
          >
            Update Template
          </button>
        </div>

        {mode && (
          <form onSubmit={handleSubmit} className="ctm-form">
            <label className="ctm-label">Select Certificate Type:</label>
            <select
              value={certificateType}
              onChange={(e) => setCertificateType(e.target.value)}
              className="ctm-select"
              required
            >
              <option value="">-- Select Certificate Type --</option>
              <option value="completion">Internship Offer Letter</option>
              <option value="excellence">Internship Completion Certificate</option>
            </select>

            <label className="ctm-label">
              {mode === "add" ? "Upload PDF Template:" : "Update PDF Template:"}
            </label>
            <input
              type="file"
              accept="application/pdf"
              className="ctm-file"
              onChange={handleFileChange}
              required
            />

            <button type="submit" className="ctm-btn ctm-primary">
              {mode === "add" ? "Add Template" : "Update Template"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default CertificateTemplateManager;
